module.exports = new __parcel__URL__("C9S1.0d1df72d.png").toString();